import { getDataLayer } from "../trackingHelper";
import { Cart } from "@insite/client-framework/Services/CartService";

export default function checkoutReviewAndPayTracking(cart?: Readonly<Cart>) {
    const dataLayer = getDataLayer();
    if (!dataLayer) {
        return;
    }
    const dataLayerProducts: any[] = [];
    cart?.cartLines?.forEach(cartLine => {
        const isHazardous = cartLine?.properties?.isHazardousGood.toLowerCase() === 'true' ? 'Yes' : '';
        dataLayerProducts.push({
            name: cartLine.shortDescription,
            id: cartLine.erpNumber,
            price: cartLine?.pricing?.actualPrice,
            quantity: cartLine.qtyOrdered,
            category: cartLine?.properties?.cartlineCategoryName,
            list: cartLine?.properties?.productSourceActionField || "",
            listid: cartLine?.properties?.listIdField || "",
            position: cartLine?.properties?.productListPosition || "",
            brand: cartLine?.properties?.cartLineBrandName,
            condition: cartLine?.properties?.cartLineCondition,
            Hazardous: isHazardous
        });
    });
    const data = {
        'checkout': {
            'actionField': { 'step': 3, 'option': 'Payment Details', 'action': 'checkout' },
            'products': dataLayerProducts,
            'cartId': cart?.orderNumber
        }
    };
    const ecommerceObj = { 'event': 'checkout', ecommerce: data };
    dataLayer.push({ ecommerce: null });
    dataLayer.push(ecommerceObj);
};